import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

const MyInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const isPasswordType = props.type === 'password';
  const inputType = isPasswordType && showPassword ? "text" : props.type;

  return (
    <div className={props.wrapClass ? props.wrapClass + " form-group" : ' form-group' && props.children ? 'input-group' : ''}>
      {props.heading &&
        // Phase C.7.4D-R1 (§4 Required Red Asterisk Overlap Root-Cause Fix): {props.heading} and the
        // asterisk span used to sit on separate JSX lines — whitespace-only text that spans a line
        // break is stripped entirely by JSX (not collapsed to a space), so the asterisk rendered with
        // literally zero gap after the label text (e.g. "Email ID*"), visually merging into the last
        // character at normal letter-spacing — live-confirmed via screenshot. `.ent-required-asterisk`
        // gives it a small, explicit margin so it can never collide with the preceding text regardless
        // of surrounding whitespace/line-height context, instead of relying on fragile JSX formatting.
        <label htmlFor={props.name} className="card-holder-name">{props.heading}
          {props.isRequired && <span className="color-red ent-required-asterisk">*</span>}
        </label>
      }

      <div style={{ position: 'relative' }}>
        <input
          id={props.name}
          name={props.name}
          type={inputType}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onKeyDown={props.onKeyDown}
          readOnly={props.isReadOnly}
          placeholder={props.placeholder}
          disabled={props.disabled}
          style={props.style}
          maxLength={props.maxlength}
          onCopy={props.onCopy}
          onPaste={props.onPaste}
          onCut={props.onCut}
          autoComplete="off"
          className={`form-control ${props.className || ''} ${
            // Phase C.7.4D-R1 (§3 Unexpected "X" Icons Root-Cause Fix): several callers (NewLogin.jsx,
            // ResetPassword.jsx, SetPassword.js, and every staff Admin/BankAdmin/HelpDesk/Biometric
            // login) pass a tri-state field ("" / "success" / "error") into `errorState`, rather than
            // the error MESSAGE string most other callers use (which is "" when valid, so a plain
            // truthy check works fine for them). Under the old plain `props.errorState &&` check, the
            // literal string "success" is just as truthy as "error" or a real message — so a validly
            // filled field rendered `has-error` (red border) and the close-circle error icon below,
            // with an empty message, exactly reproducing "unexpected X icons" next to already-valid
            // Application ID/Password fields. Excluding the literal "success" value fixes every
            // tri-state caller and is a no-op for message-string callers (their messages are never
            // literally the word "success").
            props.errorState && props.errorState !== 'success' ? 'has-error' : (props.successState ? 'has-success' : '')
          }`.trim()}
        />

        {isPasswordType && (
          <span
            onClick={togglePasswordVisibility}
            role="button"
            tabIndex={0}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                togglePasswordVisibility();
              }
            }}
            className="ent-input-toggle-icon"
          >
            <i className={`fa ${showPassword ? 'fa-eye' :'fa-eye-slash'}`}></i>

          </span>
        )}
      </div>

      {props.children}
      {props.errorState && props.errorState !== 'success' && (
        <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{props.errorMessage}</label>
      )}
      {props.successState && props.successMessage && !props.errorState && (
        <label className="ent-input-success d-block"><Icon type="check-circle" className="mr-1" />{props.successMessage}</label>
      )}
      {props.isInfoLabel && props.infoText}
    </div>
  );
};

MyInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  errorState: PropTypes.string,
  isReadOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  heading: PropTypes.any,
  isRequired: PropTypes.bool,
  wrapClass: PropTypes.string,
  errorMessage: PropTypes.string,
  style: PropTypes.any,
  maxlength: PropTypes.any,
  isInfoLabel: PropTypes.bool,
  infoText: PropTypes.string,
  onCopy: PropTypes.func,
  onPaste: PropTypes.func,
  onCut: PropTypes.func,
  successState: PropTypes.string,
  successMessage: PropTypes.string,
};

export default MyInput;
